import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=7806bf30"
import script from "./invitations.vue?vue&type=script&lang=ts"
export * from "./invitations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports